import React from "react";

export const useSessionState = (
  defaultValue,
  key
)  => {
  const [value, setValue] = React.useState(() => {
    const stickyValue = window.sessionStorage.getItem(key);
    return stickyValue !== null ? JSON.parse(stickyValue) : defaultValue;
  });

  React.useEffect(() => {
    window.sessionStorage.setItem(key, JSON.stringify(value));
  }, [key, value]);

  return [value, setValue];
};

export const useInput = (initialValue) => {
  const [value, setValue] = React.useState(initialValue)

  const handleChange = (e) => { setValue(e.target.value) }

  return [value, handleChange, setValue]
}
